exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".show-more-wrapper .link-arrow[data-v-5ebec418] {\n  cursor: pointer;\n}\n.v-collapse-content-end + .link-arrow[data-v-5ebec418] {\n  display: none;\n}", ""]);

// exports
